const cookiesModal = () => {

    const cookiesForm = document.getElementById('cookies-form');
    const cookieAcceptBtn = cookiesForm.querySelector('[data-cookies-btn="accept"]');
    const cookieRefuseBtn = cookiesForm.querySelector('[data-cookies-btn="refuse"]');

    //if cookies accepted then hide this modal
    if (navigator.cookieEnabled == false){
        cookiesForm.classList.remove('dn');
        setTimeout(() => {
            cookiesForm.classList.remove('closed');
        }, 1);
    }

    //check which of buttons was clicked
    let clickedBtn;

    //accept btn click
    cookieAcceptBtn.addEventListener('click', () => {
        clickedBtn = 1;
        return clickedBtn;
    });

    //refuse btn click
    cookieRefuseBtn.addEventListener('click', () => {
        clickedBtn = 0;
        return clickedBtn;
    });


    //form logic
    cookiesForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (clickedBtn = 0) {
            return;
        }

        //Creating FormData object
        const fData = 'i_accept_cookies';
        const fAction = cookiesForm.getAttribute('action');

        //Sending form to server
        await fetch(fAction, {
            method: 'POST',
            body: fData
        });

        //close form
        cookiesForm.classList.add('closed');
        setTimeout(() => {
            cookiesForm.classList.add('dn');
        }, 401);

    });

}

export {cookiesModal};